import { render, staticRenderFns } from "./StatInspItemActions.vue?vue&type=template&id=3348c61b"
import script from "./StatInspItemActions.vue?vue&type=script&lang=js"
export * from "./StatInspItemActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports